export function formatCurrency(value, currency) {
  return value.toLocaleString('en-US', {
    style: 'currency',
    currency: currency,
  })
}
